import { Trans } from '@lingui/react'

import { useIgnoreCrossCheckWarningMutation } from '@twisto/api-graphql'
import { TextButton } from '@twisto/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { BigWarningIcon } from '@twisto/icons'

import { useGoBack, useSubmittingWrapper } from '../../components'
import { useFlow } from '../../flow/flow.context'

import * as styles from './cross-check-warning-step.styles'

export const CrossCheckWarningStep = () => {
  const { flow, sessionId } = useFlow<'CrossCheckWarningStep'>()
  const [ignoreWarning] = useIgnoreCrossCheckWarningMutation()
  const goBackInFlow = useGoBack(sessionId)
  const submittingWrapper = useSubmittingWrapper()

  const { heading, text, disclaimer } = flow.currentStep

  const handleGoBack = () => submittingWrapper(goBackInFlow())

  const handleContinue = () =>
    submittingWrapper(
      ignoreWarning({
        variables: {
          auth: {
            sessionId,
          },
        },
      })
    )

  return (
    <>
      <Headline align="center">
        <HeadlineIcon>
          <BigWarningIcon color="warning" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>{heading}</HeadlineTitle>
        <HeadlineSubtitle>{text}</HeadlineSubtitle>
        <HeadlineSubtitle>{disclaimer}</HeadlineSubtitle>
      </Headline>
      <div css={styles.buttons}>
        <TextButton onClick={handleGoBack}>
          <Trans id="flow.crossCheckWarningStep.noGoBack" />
        </TextButton>
        <TextButton color="secondary" onClick={handleContinue}>
          <Trans id="flow.crossCheckWarningStep.yesContinue" />
        </TextButton>
      </div>
    </>
  )
}
